<div
  class="d-flex flex-column"
  style="height: 100dvh; margin: 0; overflow: hidden"
>
  <div class="d-flex navbar-app">
    <app-navbar class="w-100"></app-navbar>
  </div>
  <div class="map-area-app">
    <div class="map-area-app-content">
      <app-maparea></app-maparea>
    </div>
  </div>
  <div class="footbar-app align-items-center">
    <app-footbar></app-footbar>
  </div>
</div>

<toast-license></toast-license>
<dialog-license></dialog-license>
